import proj4 from 'proj4';
import type { RoadworkItem } from '../../lib/services/roadworksApiService';

// SRWO roadworks data uses OSGB36 / British National Grid (EPSG:27700).
// Define the projection once; proj4 replaces identical definitions safely.
proj4.defs(
  'EPSG:27700',
  '+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +datum=OSGB36 +units=m +no_defs +towgs84=446.448,-125.157,542.06,0.1502,0.247,0.8421,-20.4894'
);

export function bngToLngLat(easting: number, northing: number): [number, number] | null {
  try {
    if (easting < 100000 || easting > 700000 || northing < 500000 || northing > 1250000) {
      return null;
    }
    const [lng, lat] = proj4('EPSG:27700', 'EPSG:4326', [easting, northing]);
    if (!Number.isFinite(lng) || !Number.isFinite(lat)) return null;
    return [lng, lat];
  } catch {
    return null;
  }
}

export function getRoadworkCoords(item: RoadworkItem): [number, number] | null {
  if (item.latitude != null && item.longitude != null) {
    const lat = Number(item.latitude);
    const lng = Number(item.longitude);
    if (Number.isFinite(lat) && Number.isFinite(lng) && lat !== 0 && lng !== 0) {
      return [lng, lat];
    }
  }

  if (item.easting != null && item.northing != null) {
    const e = Number(item.easting);
    const n = Number(item.northing);
    if (Number.isFinite(e) && Number.isFinite(n) && e > 0 && n > 0) {
      return bngToLngLat(e, n);
    }
  }

  return null;
}

export function getImpactColor(impact: string): string {
  const t = String(impact ?? '').toLowerCase();
  if (t.includes('road closure') || t.includes('road closed')) return '#FF4D4F';
  if (t.includes('high')) return '#FF8C00';
  if (t.includes('medium') || t.includes('moderate')) return '#D3AF37';
  if (t.includes('low') || t.includes('minimal')) return '#4ADE80';
  return '#94a3b8';
}

export function getImpactRank(impact: string): number {
  const t = String(impact ?? '').toLowerCase();
  if (t.includes('road closure')) return 4;
  if (t.includes('high')) return 3;
  if (t.includes('medium') || t.includes('moderate')) return 2;
  if (t.includes('low') || t.includes('minimal')) return 1;
  return 0;
}
